export interface Schedule {
  id: number;
  station_ids?: number[];
  schedules_id?: number | null;
  category?: string;
  status: number;
  title: string;
  description?: string;
  allDay: boolean
  duration?: number;
  end?: any;
  freq: string;
  interval: number;
  byweekday: Array<number>;
  byminute: Array<number>;
  byhour: Array<number>;
  dtstart: string;
  until: any;
  saved: boolean;
  focus: boolean;
  editable: boolean;
  style?: ScheduleStyle;
}

export interface EditSchedule {
  id: number;
  station_ids?: number[];
  schedules_id?: number | null;
  category?: string;
  status?: number;
  title?: string;
  description?: string;
  freq?: string;
  interval?: number;
  byweekday?: Array<any>;
  byhour?: Array<any>;
  byminute?: Array<any>;
  dtstart?: string;
  until?: any;
  duration?: number;
  end?: any;
  saved?: boolean;
  focus?: boolean;
  editable?: boolean;
  style?: ScheduleStyle;
}

export interface NewSchedule {
  dtstart?: string;
  duration?: number;
  end?: any;
  byweekday?: Array<any>;
  byminute?: Array<any>;
  byhour?: Array<any>;
  style?: ScheduleStyle;
  category: string;
  title: string;
}

export interface SavedSchedule {
  id?: number;
  dtstart?: string;
  duration?: number;
  end?: any;
  byweekday?: Array<any>;
  byminute?: Array<any>;
  byhour?: Array<any>;
  style?: ScheduleStyle;
  category: string;
  title: string;
}

export interface ScheduleStyle {
  background?: string;
  border?: string;
}

export interface RuleSlice {
  id: number;
  rule_id: number;
  account_id: number;
  title: string;
  description: string;
  category: string;
  station_id: number;
  schedules_id: number;
  status: number;
  meta: Meta[];
  saved: boolean;
  wrx_option_id: number | null;
}

export interface EditRule {
  id: number;
  rule_id?: number;
  account_id?: number;
  title?: string;
  description?: string;
  category?: string;
  station_id?: number;
  schedules_id?: number;
  status?: number;
  meta?: Meta[]
  saved?: boolean; 
  wrx_option_id?: number | null
}

export interface SavedRule {
  id?: number;
  rule_id?: number;
  account_id?: number;
  title?: string;
  description?: string;
  category?: string;
  station_id?: number;
  schedules_id?: number;
  status?: number;
  meta?: Meta[]
  saved?: boolean; 
  wrx_option_id?: number | null;
}

export interface Meta {
  entity: string;
  value: string;
}

export enum Status {
  ACTIVE = 1,
  DISABLED = 2,
  DETACHED = 3
}

export interface WrxOptionSlice {
  id: number;
  wrx_option_id: number;  
  description: string;  
}